<template>
<div>
  <span v-if="debug === 'true' || debug === true">{{version}}</span>
  <b-container fluid="">
    <b-row class="divSubtitulo m-1 mb-3">
      <b-col cols="6" md="8">
      </b-col>
      <b-col cols="6" md="4">
        <div>
          <p style="text-align:end" class="textoSubtitulo">CÓDIGO: PX_Cupones</p>
        </div>
      </b-col>
    </b-row>
  </b-container>

  <b-row>
    <b-col class="text-right ">
      <b-button-group style="height: 20px; font-size: 12px; font-weight: bold " >
        <div :class="!vigentesNoDisponibles ? 'tabOpciones seleccionado' : 'tabOpciones'"
                  @click="cambiarVistaVigentes()" v-if="$localStorageService.can('Cupon_vigente')" class="mr-3">
          <span class="m-3">Cupones vigentes</span>
        </div>
        <div :class="vigentesNoDisponibles ? 'tabOpciones seleccionado' : 'tabOpciones'"
                  @click="cambiarVistaNoDisponibles()"   v-if="$localStorageService.can('Cupon_vencido')">
          <span class="m-2">Cupones No Disponibles</span>
        </div>
      </b-button-group>
    </b-col>
  </b-row>

  <b-row>
    <b-col v-if="!vigentesNoDisponibles">
      <cupones-vigentes :idPaciente = "idPaciente"/>
    </b-col>
    <b-col v-else>
      <cupones-no-disponibles :idPaciente = "idPaciente" />
    </b-col>
  </b-row>




</div>
</template>

<script>


import CuponesVigentes from "@/views/perfilPacientes/cuponesVigentes.vue";
import CuponesNoDisponibles from "@/views/perfilPacientes/cuponesNoDisponibles.vue";

export default {
  name: "cuponera",
  components:{
    CuponesNoDisponibles,
    CuponesVigentes
  },

  data:()=>{
    return{
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,

      vigentesNoDisponibles:false,

    }

  },
  props:{
    idPaciente: Number,
  },
  methods:{
    cambiarVistaVigentes() {
      this.vigentesNoDisponibles = false;
    },
    cambiarVistaNoDisponibles() {
      this.vigentesNoDisponibles = true;
    },
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
  }
}

</script>

<style scoped>
.boton-agenda-switch {
  border-radius: 50rem;
  color: #fff;
  background-color: var(--color-icono);
  border-color: var(--color-icono);
  margin-right: 2px;
}
.boton-agenda-switch {
  background: white;
  border: none !important;
  padding: 3px !important;
  color: gray;
  font-size: 10px;
  font-weight: bolder;
}
.boton-agenda-switch-active {
  background-color: white;
  border-color: var(--color-icono) !important;
  border-radius: 50px !important;
  width: 100px !important;
  padding: 3px !important;
  color: var(--color-icono) !important;
  font-size: 10px;
  font-weight: bolder;
}


.tabOpciones{
  border-style: solid;
  border-width: 1px;
  border-color: white;
  border-radius: 10px;
  color: #5D5D5D;
}

.tabOpciones.seleccionado{

  border-style: solid;
  border-width: 1px;
  border-color: #17a2b8;
  border-radius: 7px;
  color: #17a2b8;
  box-shadow: 0px 6px 14px -6px rgba(0,0,0,0.44);
}

.tabOpciones:hover{
  box-shadow: 0px 6px 14px -6px rgba(0,0,0,0.44);
}


</style>